import React from "react";
import HomeMiddleBanners from "../components/HomeMiddleBanners";
import { t } from "../../../helpers";
import { PHOTOS_URL } from "../../../constants";

type ImStatelessProps = {
  lang: string;
  country: string;
};

const MiddleBanners = React.memo<ImStatelessProps>((props) => {
  return (
    <section
      className="middleBanner container"
      style={{ backgroundImage: `url(${PHOTOS_URL}trustcocunatbG.png)` }}
    >
      <h1 className="align-left">{t("home.trustInCocunatTitle")}</h1>
      <p
        style={{ textAlign: "center" }}
        dangerouslySetInnerHTML={{ __html: t("home.trustInCocunatText") }}
      ></p>
      <HomeMiddleBanners
        title={t("home.middleBanner1Title")}
        text={t("home.middleBanner1Text")}
        img="homeMiddleBanner-1.png"
        link={`/${props.lang}-${props.country}/quizz/1/`}
      />
      <HomeMiddleBanners
        title={t("home.middleBanner2Title")}
        text={t("home.middleBanner2Text")}
        img="homeMiddleBanner-2.png"
        link={`/${props.lang}-${props.country}/quizz/1/`}
      />
      <HomeMiddleBanners
        title={t("home.middleBanner3Title")}
        text={t("home.middleBanner3Text")}
        img="homeMiddleBanner-3.png"
        link={`/${props.lang}-${props.country}/quizz/1/`}
      />
      <HomeMiddleBanners
        title={t("home.middleBanner4Title")}
        text={t("home.middleBanner4Text")}
        img="homeMiddleBanner-4.png"
        link={`/${props.lang}-${props.country}/quizz/1/`}
      />
      <HomeMiddleBanners
        title={t("home.middleBanner5Title")}
        text={t("home.middleBanner5Text")}
        img="homeMiddleBanner-5.png"
        link={`/${props.lang}-${props.country}/quizz/1/`}
      />
    </section>
  );
});
export default MiddleBanners;
